import { Locale } from '@ps-smart-cp/ppfw-client';

const smallLeaseJudgeBasisJapanConfig = {
  threeMillionYenBasis: new Map([[Locale.ja, '300万円基準']]),
  fiveThousandDollarBasis: new Map([[Locale.ja, '5000米ドル基準']]),
};

export { smallLeaseJudgeBasisJapanConfig };
